import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBurst: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"burst, pop, boom"} maskId="square-filled-radius-0-stroke-1-IconBurst"><path d="M11.5 19H12.5V23H11.5V19ZM8.70703 16L4.5 20.207L3.79297 19.5L8 15.293L8.70703 16ZM20.207 19.5L19.5 20.207L15.293 16L16 15.293L20.207 19.5ZM5 11.5V12.5H1V11.5H5ZM23 11.5V12.5H19V11.5H23ZM8.70703 8L8 8.70703L3.79297 4.5L4.5 3.79297L8.70703 8ZM20.207 4.5L16 8.70703L15.293 8L19.5 3.79297L20.207 4.5ZM11.5 1H12.5V5H11.5V1Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBurst;
